import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import type { IFileParser } from "./IFileParser";

class GltfFileParser implements IFileParser {
	readonly supportedExtensions = ["gltf", "glb"] as const;

	async parse(file: File): Promise<THREE.Object3D> {
		const buffer = await file.arrayBuffer();
		const loader = new GLTFLoader();

		return new Promise((resolve, reject) => {
			loader.parse(
				buffer,
				"",
				(gltf) => {
					const model = gltf.scene;

					// Center the object at origin
					const box = new THREE.Box3().setFromObject(model);
					const center = box.getCenter(new THREE.Vector3());
					model.position.sub(center);

					model.name = model.name || file.name.split(".")[0] || "GLTF_Model";

					resolve(model);
				},
				(error) => reject(new Error(`Failed to parse GLTF: ${error}`)),
			);
		});
	}
}

export { GltfFileParser };
